import React from 'react';
import PropTypes from 'prop-types';

import './video.scss';
import './youtube.scss';

class YoutubeVideo extends React.Component {
  render() {
    return (
      <div className='video-winner'>
        <div className='youtube_responsive_padding'>
          <div className='youtube_responsive_wrapper'>
            <iframe
              src={`https://www.youtube.com/embed/${this.props.youtubeID}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`}
              width='1920'
              height='1080'
              frameBorder='0'
              allowFullScreen
              uk-responsive
              uk-video
              title='Fresh Fund'
            />
            <div className='video-caption uk-margin-top'>{this.props.caption}</div>
          </div>
        </div>
      </div>
    );
  }
}

YoutubeVideo.defaultProps = {
  youtubeID: '61c2rTUIg5Q',
  caption: '',
};

YoutubeVideo.propTypes = {
  youtubeID: PropTypes.string,
  caption: PropTypes.string,
};

export default YoutubeVideo;
